import React, { useState, useMemo, useEffect } from 'react';
import MaterialTable from 'material-table';
import { Chip, TextField, Tooltip, Typography, withStyles } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { BackButton, localization, getDimensionsOfPagination } from '../../sc-utilities';
import DataRange from '../../sc-utilities/DateRange';
import * as actions from './store/statisticActions';
import * as action from '../../np-core/Auth/store/authActions';
import { connect } from 'react-redux';
import * as Yup from "yup";
import moment from 'moment'
import { Redirect } from 'react-router-dom';
import { CsvBuilder } from 'filefy';
import { Autocomplete } from '@material-ui/lab';
import momentTimezone from 'moment-timezone';


const styles = theme => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
        "[class*='.MuiButton-root']": {
            minWidth: '24px',
            borderRadius: '1px'
        },
    },
    title: {
        marginLeft: 14,
        width: "900px",
        paddingTop: '4px'
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
        paddingTop: '4px'
    },
    tableTitleRefresh: {
        marginBottom: '32px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    autocomplete: {
        width: "500px",
        paddingLeft: "60px",
        paddingBottom: "18px"
    },
    customTooltip: {
        marginLeft: -16
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const StatisticList = props => {
    const { classes, translations, method, getDiagnoseStatus, redirectOptions, activeCustomerID, saveColumnsFilter, tableColumns, statistics, fetchStatisticDataCount, fetchStatisticData, tableRef, fetchCustomers, fetchCustomer } = props;
    const fetching = statistics.fetching;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , [tableColumns]);

    const [allCustomers, setAllCustomers] = useState([]);
    const [excludedCustomers, setExcludedCustomers] = useState([])

    let from = moment().subtract(2, 'days').set({
        hours: 0,
        minutes: 0,
        seconds: 0
    })
    let to = moment().set({
        hours: 23,
        minutes: 59, seconds: 59
    })
    const [dateRangeValue, setDateRangeValue] = useState(null);

    const customExport = (columnData, statisticsList) => {
        let columns = [...columnData]
        let columnsArray = columns.filter(column => !(column.export === false))
        let columnsToSend = columnsArray.map(columnDef => columnDef.title).sort()

        const data = statisticsList.map(statistic => {
            let storageComponent = typeof statistic.Components === 'object' && statistic.Components[0].StorageComponents instanceof Array && statistic.Components[0].StorageComponents.length > 0 ? statistic.Components[0].StorageComponents[0] : false;
            let returnObj = [
                statistic?.Colli?.ColliInventoryID || translations['short_not_assigned'] || 'n/a',
                statistic.DiagnoseSessions && statistic.DiagnoseSessions.length > 0 && statistic.DiagnoseSessions[0].DiagnoseSessionCases ? getDiagnoseStatus(statistic.DiagnoseSessions[0].DiagnoseSessionCases) : translations['short_not_assigned'] || 'n/a',
                statistic?.InventoryID || translations['short_not_assigned'] || 'n/a',
                statistic && statistic?.Type === 'MobileProduct' ? statistic?.MobileProduct?.MobileProductModel || translations['short_not_assigned'] || 'n/a' : statistic?.PCProduct?.Name || translations['short_not_assigned'] || 'n/a',
                statistic?.Order?.OrederInventoryID || translations['short_not_assigned'] || 'n/a',
                statistic?.TransportColli?.TransportColliInventoryID || translations['short_not_assigned'] || 'n/a',
                statistic?.Vendor || translations['short_not_assigned'] || 'n/a',
                storageComponent ? storageComponent['WipeStarted'] : translations['short_not_assigned'] || 'n/a',
                storageComponent ? method[storageComponent['WipeMethod']] : translations['short_not_assigned'] || 'n/a',
                storageComponent ? storageComponent['WipeStatus'] : translations['short_not_assigned'] || 'n/a',
            ];
            return returnObj;
        });
        const builder = new CsvBuilder(`securaze_erasure_statistic_${Math.floor(Date.now() / 1000)}.csv`);
        builder
            .setDelimeter('\t')
            .setColumns(columnsToSend)
            .addRows(data)
            .exportFile();
    };


    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: false,
        search: false,
        filterCellStyle: { maxWidth: '150px' },
        minBodyHeight: window.innerHeight - 291 < 300 ? 300 : window.innerHeight - 291,
        maxBodyHeight: window.innerHeight - 291,
        pageSizeOptions: rowsPageSizeInit,
        exportButton: true,
        exportCsv: customExport,
        columnsButton: true,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? '#f3f3f3' : '#ffffff' };
        },
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: false
    })

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }

    useEffect(() => {
        const fetchAllCustomers = async () => {
            const customers = await fetchCustomers();
            setAllCustomers(customers);
        }
        fetchAllCustomers();     
        
    }, [fetchCustomers])

    useEffect(() => {
        const securazeCustomer = allCustomers?.find(customer => customer.label === 'Securaze');
       
        if (excludedCustomers.length === 0 && securazeCustomer) {
            setExcludedCustomers([securazeCustomer]);
            tableRef.current && tableRef.current.onQueryChange();
        };
    }, [allCustomers]);

    useEffect(() => {
        const customerTimezone = window.localStorage.getItem("CustomerTimezone") ?? 'UTC';

        const from = momentTimezone.tz(moment(), customerTimezone);

        setDateRangeValue({
            From: from,
            To: from,
            ShowOnlyMyErasures: false,
            maxDate: from.set({
                hours: 23,
                minutes: 59,
                seconds: 59,
            })
        });
        // eslint-disable-next-line
    }, [ activeCustomerID ]);


    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        query['ActiveCustomerID'] = activeCustomerID;
        query['q'] = q;

        if (query['q'].SecurazeSolution && query['q'].SecurazeSolution.length===0) {
            query['q'].SecurazeSolution=null;
        }
        if (query['q'].WipeMethod && query['q'].WipeMethod.length===0) {
            query['q'].WipeMethod=null;
        }
        if (excludedCustomers?.length > 0) {
            query['ExcludedCustomers'] = excludedCustomers.map(customer => customer.value)
        } else {
            delete query['ExcludedCustomers']
        }

        query['From'] = dateRangeValue?.From.format('YYYY-MM-DD');
        query['To'] = dateRangeValue?.To.format('YYYY-MM-DD');

        let count = await fetchStatisticDataCount(query);
        if (!query['page'] && !rowsPageSizeInit.includes(query['pageSize'])) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions?.pageSize
            rowsPageSizeInit = dimensions?.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await fetchStatisticData(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Key: Yup.string().required("Required"),
        }
    };

    const filterDataRange = async (range) => {
        dateRangeValue.From = range.From
        dateRangeValue.To = range.To
        tableRef.current && tableRef.current.onQueryChange()
    };

    const filterDataMyErasure = async (checked) => {
        setDateRangeValue({ From: dateRangeValue?.From, To: dateRangeValue?.To, query: {}, ShowOnlyMyErasures: checked })
        tableRef.current && tableRef.current.onQueryChange()
    };

    const updateExcludedCustomersData = (data) => {
        setExcludedCustomers(data)
        tableRef.current && tableRef.current.onQueryChange()
    }
    
    const tableTitle = () => {
        return <div className={classes.title}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography>
                    {translations["erasures_last"] || 'Asset statistic'}
                </Typography>
            </div>
            <div className={classes.tableTitleRefresh}>
                {dateRangeValue && <DataRange
                    formSettings={formSettings}
                    initialValues={dateRangeValue}
                    filterDataRange={filterDataRange}
                    value={dateRangeValue}
                    filterDataMyErasure={filterDataMyErasure}
                    setValue={setDateRangeValue}
                    format="yyyy/MM/dd 00:00:00"
                    translations={translations}
                    minDate={moment().subtract(1, 'years')}
                />}
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <Refresh disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()} color="action" />
                </Tooltip>

                <Autocomplete
                    className={classes.autocomplete}
                    name={'ExcludedCustomers'}
                    multiple
                    id="ExcludedCustomersMultiSelect"
                    options={allCustomers || []}
                    getOptionLabel={(option) => option.label}
                    filterSelectedOptions
                    value={excludedCustomers}
                    onChange={(_, value) => updateExcludedCustomersData(value)}

                    renderInput={(params) => (
                        <TextField {...params} variant="standard" fullWidth={true} label={`${translations["exclude_customers"] || "Exclude customers"}...`} />
                    )}
                />
            </div>

        </div>
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`Statistic`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID })
        return newColumnState
    }

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <>
            <MaterialTable
                tableRef={tableRef}
                title={tableTitle()}
                columns={columnObject}
                onChangeRowsPerPage={(size) => {
                    pageSize = size
                }}
                data={fetchTableData}
                statistic={true}
                options={tableOptions}
                isLoading={fetching}
                onChangeColumnHidden={columnHidden}
                localization={localization(translations)}
                onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
            />
        </>)
}

const mapDispatchToProps = dispatch => {
    return {
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        fetchStatisticData: filter => dispatch(actions.fetchStatisticData(filter)),
        fetchStatisticDataCount: filter => dispatch(actions.fetchStatisticDataCount(filter)),
        fetchCustomers: data => dispatch(actions.fetchCustomers(data)),
        fetchCustomer: data => dispatch(actions.fetchCustomer(data))
    };
};

const mapStateToProps = state => {
    return {
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID || null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        statistics: state.statistic.statistics
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(StatisticList));
